<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('area_groups.title')"/>
        <div class="col-sm-12 nopads">

          <!-- AreaGroup list -->
          <Transition name="fade">
            <area-group-list
              v-if="!editMode"
              class="my-2"
              :area-groups="areaGroups"
              @add="addAreaGroup"
              @edit="editAreaGroup"
            />
          </Transition>

          <!-- Editor -->
          <Transition name="fade">
              <base-modal size="lg" v-if="editMode" hide-header hide-footer @close="closeEditor">
                  <area-group-editor
                      :area-group="selectedAreaGroup"
                      @close="closeEditor"
                      @close-and-update="closeEditorAndUpdate"
                  />
              </base-modal>
          </Transition>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import AreaGroupList from './AreaGroupList'
import AreaGroupEditor from './AreaGroupEditor'
import CompanyFilter from '../../company/CompanyFilter'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'AreaGroups',
    components: {BaseModal, Navbar, CompanyFilter, AreaGroupList, AreaGroupEditor},
    mixins: [restApi],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            areaGroups: [],
            selectedAreaGroup: null,
            fetchCompany: null,
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
        this.fetchAreaGroups()
    },
    methods: {
        fetchAreaGroups: function () {
            this.areaGroups = []
            this.loading = true
            let params = {}
            params.no_geom = 1
            this.restFetchParams(this.areaGroupUrl, params, this.handleAreaFetchResponse)
        },
        handleAreaFetchResponse: function (response) {
            this.loading = false
            if (response != null) {
                // It is ok to get all area groups for normal users, but just filter the result in this view to show only the ones that belong to the user's company
                let groups = response.data
                if (!!this.user) {
                    groups = response.data.filter(group => group.company_area === this.user.company.id)
                }
                this.areaGroups = groups
            }
        },
        addAreaGroup: function () {
            this.selectedAreaGroup = {id: -1, name: '', company: {}, areas: [], is_inactive: false}
            this.editMode = true
        },
        editAreaGroup: function (group) {
            this.selectedAreaGroup = group
            this.editMode = true
        },
        closeEditor: function () {
            this.editMode = false
        },
        closeEditorAndUpdate: function () {
            this.fetchAreaGroups()
            this.closeEditor()
        }
    }
}
</script>
